import angular from "angular"

const factory = [
  "$http",
  "fichaAlumnoService",
  function($http, fichaAlumnoService) {
    function getAtenciones() {
      return $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "get_atenciones/"
      }).then(function(response) {
        return response.data
      })
    }

    function getTiposAcciones() {
      return $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "get_tipos_acciones/"
      }).then(function(response) {
        return response.data
      })
    }

    function getTipoAlertas() {
      return $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "get_tipos_alertas/"
      }).then(function(response) {
        return response.data
      })
    }

    function postAccion(data) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "post_accion/",
        data: JSON.stringify(data)
      }).then(function(response) {
        return response.data
      })
    }

    function updateAcciones(models) {
      console.log(models)
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "update_accion/",
        data: JSON.stringify(models)
      }).then(function(response) {
        return response.data
      })
    }

    function deleteAcciones(models) {
      console.log(models)
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "delete_accion/",
        data: JSON.stringify(models)
      }).then(function(response) {
        return response.data
      })
    }

    function postCategoria(data) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "post_categoria/",
        data: JSON.stringify(data)
      }).then(function(response) {
        return response.data
      })
    }

    function updateCategorias(models) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "update_categoria/",
        data: JSON.stringify(models)
      }).then(function(response) {
        return response.data
      })
    }

    function deleteCategorias(models) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "delete_categoria/",
        data: JSON.stringify(models)
      }).then(function(response) {
        return response.data
      })
    }

    function postTipoAlerta(data) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "post_tipo_alerta/",
        data: JSON.stringify(data)
      }).then(function(response) {
        return response.data
      })
    }

    function updateTipoAlertas(models) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "update_tipo_alerta/",
        data: JSON.stringify(models)
      }).then(function(response) {
        return response.data
      })
    }

    function deleteTipoAlertas(models) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "delete_tipo_alerta/",
        data: JSON.stringify(models)
      }).then(function(response) {
        return response.data
      })
    }

    function getPendientes(args) {
      return $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "notificar_atenciones_vencidas/",
        params: args
      }).then(function(response) {
        return response.data
      })
    }

    return {
      getAtenciones: getAtenciones,
      getTiposAcciones: getTiposAcciones,
      getTipoAlertas: getTipoAlertas,
      updateAcciones: updateAcciones,
      deleteAcciones: deleteAcciones,
      postAccion: postAccion,
      postCategoria: postCategoria,
      updateCategorias: updateCategorias,
      deleteCategorias: deleteCategorias,
      postTipoAlerta: postTipoAlerta,
      updateTipoAlertas: updateTipoAlertas,
      deleteTipoAlertas: deleteTipoAlertas,
      getPendientes: getPendientes
    }
  }
]

angular.module("appModule").factory("atencionesService", factory)
